<div id="tv-multi-select">
  <div class="select-trigger"
       [attr.dpad]="dpad"
       [style.--scale-dpad]="scaledpad"
       [attr.x-dpad]="xdpad"
       [attr.y-dpad]="ydpad"
       [attr.tab-dpad]="tabdpad"
       [attr.x-tab-dpad]="xtabdpad"
       [attr.y-tab-dpad]="ytabdpad"
       [id]="id"
       [class.select-disable]="disabled"
       (click)="openDialog()"
       tabindex="0">
    <span class="summary">{{ selectedValues.length + ' ' + COMMON_TEXT.ITEM_SELECTED_TV }}</span>
    <i class="multi-sl-icon pi pi-angle-down"></i>
  </div>

  <div class="tv-overlay" [class.show]="dialogVisible"
       (click)="false && onCancel()"></div>

  <div class="tv-modal-shell"  #dialogmuti *ngIf="dialogVisible" [class.show]="true">
    <div class="tv-modal-panel">
      <ul class="tv-list">
        <li *ngFor="let item of options; let idx = index"
            class="option-item"
            [attr.scaledpad]="1"
            [attr.dpad]="currentZone"
            [attr.x-dpad]="0"
            [attr.y-dpad]="idx"
            [class.checked]="selectedValues.includes(item.value)"
            (click)="toggleValue(item.value)">
          <span class="checkbox">{{ selectedValues.includes(item.value) ? '✔' : '' }}</span>
          <span class="label-multi-select">{{ item.name || '' }}</span>
        </li>
        <div class="no-data-txt" *ngIf="options.length === 0">{{COMMON_TEXT.NO_DATA}}</div>
      </ul>
    </div>
  </div>
</div>